module.exports = __webpack_public_path__ + "media/images/connect_dots_icon-680d059b97937091fe45093eb09c1003.png";